var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"te-body vh-100",attrs:{"id":"app"}},[_c('router-view'),_c('AwardInformationPopup'),(_vm.loading)?_c('Loading'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }